$width: 20px
$height: 40px

.PragotronContainer
    position: relative
    width: 158px
    height: 86px
    .PragotronLine
        position: absolute
        left: 10px
        right: 10px
        top: 42.5px
        height: 2px
        background: black
        opacity: 0.5
        z-index: 3
    .PragotronNumbers
        position: absolute
        left: 0
        right: 0
        top: 1px
        bottom: 0
        display: flex
        justify-content: center
        align-items: center
        .NumberContainer
            position: relative
            width: $width
            height: $height
            color: white
            font-size: $height * 0.8
            font-weight: bold
            .TopUp
                position: absolute
                top: 0
                bottom: $height * 0.5
                overflow: hidden
                animation: topPart 0.3s cubic-bezier(.37,.01,.94,.35)
                animation-fill-mode: both
                transform-origin: center bottom
                z-index: 2
            .TopUnder
                position: absolute
                top: 0
                bottom: $height * 0.5
                overflow: hidden
                transform-origin: center bottom
                transform: rotateX(0deg)
            .BottomUp
                position: absolute
                top: $height * 0.5
                bottom: 0
                display: flex
                align-items: flex-end
                overflow: hidden
                animation: bottomPart 0.6s cubic-bezier(.15,.45,.28,1)
                animation-fill-mode: both
                transform-origin: center top
                opacity: 0
                z-index: 2
            .BottomUnder
                position: absolute
                top: $height * 0.5
                bottom: 0
                display: flex
                align-items: flex-end
                overflow: hidden
                z-index: 1
                transform: rotateX(0deg)
            .InsideContainer
                width: $width
                height: $height
                display: flex
                justify-content: center
                align-items: center
                background: #39363A
        .EmptyField
            width: 10px
            height: $height
            color: white
            font-size: $height * 0.8
            font-weight: bold
            display: flex
            align-items: center
            justify-content: center
        .NumberContainerExpired
            color: #ff0066

@keyframes topPart
    0%
        transform: rotateX(0deg)
    0%, 99%
        opacity: 0.99
    100%
        transform: rotateX(-90deg)
        opacity: 0

@keyframes bottomPart
    0%, 50%
        transform: rotateX(90deg)
        opacity: 0
    51%
        opacity: 0.99
    100%
        opacity: 0.99
        transform: rotateX(0deg)
